import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Field, reduxForm, propTypes as formPropTypes } from 'redux-form';
import ReduxFormInput from './ReduxFormInput';
import normalizeCreditCardNumber from './normalizers/creditCardNumber';
import normalizeCreditCardCVC from './normalizers/creditCardCVC';

class Checkout extends Component {
  static propTypes = {
    ...formPropTypes,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func,
    price: PropTypes.string,
    annual: PropTypes.bool,
  };

  renderCheckoutBar() {
    return (
      <div className="checkout-bar">
        <span className="checkout-bar__label">Total</span>
        <span className="checkout-bar__value">
          <span className="checkout-bar__total-value">${this.props.price}</span>
          {this.props.annual && '/ yr'}
        </span>
      </div>
    );
  }

  render() {
    const { error, submitting, handleSubmit, onCancel, onSubmit } = this.props;
    const currentYear = new Date().getFullYear();
    const validYears = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(offset => offset + currentYear);

    return (
      <div className="credit-card-form">
        {this.props.price && this.renderCheckoutBar()}
        {this.props.price && <h3>Enter your payment information</h3>}
        {this.props.annual && (
          <p>
            An annual subscription to Tathata Golf gives all the benefits of a gym membership, at a fraction of the
            cost. Unlock your learning potential today!
          </p>
        )}
        <form onSubmit={handleSubmit(onSubmit)}>
          <Field name="name" component={ReduxFormInput} label="Name">
            <input type="text" />
          </Field>
          <Field
            name="number"
            component={ReduxFormInput}
            label="Credit Card Number"
            normalize={normalizeCreditCardNumber}
          >
            <input type="text" />
          </Field>
          <div className="credit-card-form__card-details">
            <Field name="exp_month" component={ReduxFormInput} label="Exp. Month">
              <select>
                <option value="">Month</option>
                <option value="1">1 - January</option>
                <option value="2">2 - February</option>
                <option value="3">3 - March</option>
                <option value="4">4 - April</option>
                <option value="5">5 - May</option>
                <option value="6">6 - June</option>
                <option value="7">7 - July</option>
                <option value="8">8 - August</option>
                <option value="9">9 - September</option>
                <option value="10">10 - October</option>
                <option value="11">11 - November</option>
                <option value="12">12 - December</option>
              </select>
            </Field>
            <Field name="exp_year" component={ReduxFormInput} label="Exp. Year">
              <select>
                <option value="" key="year">
                  Year
                </option>
                {validYears.map(year => (
                  <option value={year} key={year}>
                    {year}
                  </option>
                ))}
              </select>
            </Field>
            <Field name="cvc" component={ReduxFormInput} label="CVC" normalize={normalizeCreditCardCVC}>
              <input type="text" />
            </Field>
          </div>
          <Field name="postal_code" component={ReduxFormInput} label="Postal Code">
            <input type="text" />
          </Field>
          {error && <div className="input-validation">{error}</div>}
          <p className="credit-card-form__policy">
            By subscribing to Tathata, you agree to our{' '}
            <a href="https://tathatagolf.com/terms" target="_blank" rel="noopener noreferrer">
              Terms of Use
            </a>{' '}
            and{' '}
            <a href="https://tathatagolf.com/privacy-policy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>.
          </p>
          <div className={onCancel ? 'credit-card-form__actions' : null}>
            {onCancel && (
              <button onClick={onCancel} disabled={submitting} type="button" className="button button--theme--plain">
                Cancel
              </button>
            )}
            <button type="submit" className={onCancel ? 'button' : 'button button--large'} disabled={submitting}>
              {this.props.annual ? 'Start Subscription' : 'Submit'}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

const validate = values => {
  const errors = {};
  if (!values.name || !values.name.trim()) {
    errors.name = 'Name is required.';
  }
  if (!values.number) {
    errors.number = 'Credit card is required.';
  }
  if (!values.exp_month) {
    errors.exp_month = 'Month is required.';
  }
  if (!values.exp_year) {
    errors.exp_year = 'Year is required.';
  }
  if (!values.cvc) {
    errors.cvc = 'CVC is required.';
  }
  if (!values.postal_code) {
    errors.postal_code = 'Postal code is required.';
  }
  return errors;
};

export default reduxForm({ form: 'creditCard', validate })(Checkout);



// WEBPACK FOOTER //
// ./src/common/forms/Checkout.js